import reducer from './reducers';
import * as confirmAnalysesActions from './actions';
import * as confirmAnalysesSelectors from './selectors';

export { confirmAnalysesActions, confirmAnalysesSelectors };
export default reducer;